module.exports = __webpack_public_path__ + "static/img/pj-an94.95f5c9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/pj-an94.png
// module id = l2oG
// module chunks = 1